if (document.getElementById('novo-anuncie')) {
  var appNovoAnuncie = new Vue({
    el: '#novo-anuncie',
    data: {
      objForm: {
        nome_completo: '',
        email_responsavel: '',
        telefone_responsavel: '',
        perfil: '',
        creci: '',
        cpf: '',
        cnpj: '',
        razao_social: '',
        senha: '',
        confirmacao_senha: '',
        cidade: '',
        cidade_nome: '',
        cadastro_por_login_social: false,
        google_id: '',
        google_token: '',
        facebook_id: '',
        facebook_token: ''
      },
      etapas: {
        cadastro: true,
        login: false,
        formaPgto: false,
        confirmacaoDados: false
      },
      termosConcordo: false,
      cidades: [],
      anuncianteLogado: {},
      pagamentoSelecionado: 'cartao',
      objFormDadosPagamento: {
        cartao_titular: '',
        cartao_numero: '',
        cartao_validade: '',
        cartao_cvv: '',
        cartao_bandeira: '',
        pagamento: '',
        plano: '',
        perfil: ''
      },
      aceiteTermos: false,
      enviandoCadastro: false,
      enviandoValidacaoFormaPgto: false,
      enviandoConfirmacaoCadastro: false,
      objFormLogin: {
        email: '',
        password: '',
        _token: ''
      },
      enviandoLogin: false,
      cadastroPorLoginSocial: false,
      paginaLogin: false,
      paginaLoginUsuario: false,
      cidadeEscolhida: null,
      anuncianteLogadoPossuiPlanoAtivo: false,
      autenticacaoPorFacebook: false,
      autenticacaoPorGoogle: false,
      emailVeioAtravesDaAutenticacaoSocial: false,
      veioPeloPlanoGratisEPossuiCadastroDeAnuncianteSemPlano: false,
      jaPossuiCadastroAnunciante: false,
      usuarioEstaLogado: false
    },
    methods: {
      carregarCidades: function () {
        axios
          .get('/api/localizacao/cidades?id=slug&regiao=1')
          .then(response => {
            this.cidades = response.data[0].children
          })
          .catch(error => {})
          .finally()
      },
      trocarEtapa: function (etapa) {
        this.etapas.cadastro = false
        this.etapas.login = false
        this.etapas.formaPgto = false
        this.etapas.confirmacaoDados = false

        switch (etapa) {
          case 'login':
            this.inicializarEtapaLogin()
            this.etapas.login = true
            break
          case 'cadastro':
            this.etapas.cadastro = true
            this.iniciarlizarEtapaCadastro()
            break
          case 'formaPgto':
            this.etapas.formaPgto = true
            this.inicializarEtapaFormaPgto()
            break
          case 'confirmacaoDados':
            this.etapas.confirmacaoDados = true
            break
        }
      },
      inicializarEtapaLogin: function () {
        let _this = this

        setTimeout(function () {
          _this.renderGoogleLoginButton('btn-google-auth')
        }, 800)
      },
      iniciarlizarEtapaCadastro: function () {
        let _this = this

        setTimeout(function () {
          $.applyDataMask('.data-mask')
          _this.renderGoogleLoginButton('btn-google-cadastro')
        }, 800)
      },
      inicializarEtapaFormaPgto: function () {
        let _this = this

        setTimeout(function () {
          $.applyDataMask('.data-mask')
        }, 800)

        $(document).on('keyup', '#cartao_numero', function (e) {
          let cartao_bandeira = $.payment.cardType($(e.currentTarget).val())

          if (cartao_bandeira == null) {
            _this.objFormDadosPagamento.cartao_bandeira = ''
            return
          }

          _this.objFormDadosPagamento.cartao_bandeira = cartao_bandeira
        })
      },
      enviarCadastro: function () {
        let _this = this
        _this.enviandoCadastro = true

        if (!this.validarCadastro()) {
          _this.enviandoCadastro = false
          return false
        }

        if (this.objForm.perfil != '') {
          if (this.objForm.perfil == 'corretor' || this.objForm.perfil == 'proprietario') {
            if (!validateCPF(this.objForm.cpf)) {
              swal({
                title: 'CPF informado é inválido!',
                text: 'Confira se você digitou corretamente e tente novamente.',
                type: 'error'
              })
              _this.enviandoCadastro = false
              return false
            }
          } else {
            if (!validateCNPJ(this.objForm.cnpj)) {
              swal({
                title: 'CNPJ informado é inválido!',
                text: 'Confira se você digitou corretamente e tente novamente.',
                type: 'error'
              })
              _this.enviandoCadastro = false
              return false
            }
          }
        }

        if (this.cadastroPorLoginSocial == false && this.objForm.senha != this.objForm.confirmacao_senha) {
          swal({
            title: 'A senha informada é inválida!',
            text: 'A senha digitada está diferente da confirmação de senha.',
            type: 'error'
          })
          _this.enviandoCadastro = false
          return false
        }

        if (!this.validarEmail(this.objForm.email_responsavel)) {
          swal({
            title: 'O e-mail informado é inválido!',
            text: 'Confira se você digitou corretamente e tente novamente.',
            type: 'error'
          })
          _this.enviandoCadastro = false
          return false
        }

        axios
          .post('/anuncie-criar-conta-nova-pagina', this.objForm)
          .then(function (response) {
            if (response.data.status && response.data.status == 'error') {
              swal({
                title: 'Atenção!',
                text: response.data.message,
                type: 'warning'
              })

              _this.enviandoCadastro = false
            } else if (response.data.status && response.data.status == 'success') {
              if (_this.objFormDadosPagamento.plano == 'gratis') {
                _this.enviarCadastroPlano()
              } else {
                _this.trocarEtapa('formaPgto')
                _this.anuncianteLogado = _this.objForm
                _this.anuncianteLogado.nome = _this.objForm.nome_completo
                _this.anuncianteLogado.telefone = _this.objForm.telefone_responsavel
                _this.anuncianteLogado.cnpj = _this.objForm.cnpj
                _this.anuncianteLogado.cpf = _this.objForm.cpf
                _this.anuncianteLogado.cidade_nome = _this.objForm.cidade_nome
                _this.objFormDadosPagamento.cartao_titular = _this.objForm.nome_completo
              }
            }
          })
          .catch(function (response) {
            swal({
              title: 'Atenção!',
              text: 'Ocorreu um erro, tente novamente mais tarde.',
              type: 'warning'
            })

            _this.enviandoCadastro = false
          })
      },
      verificarSessaoUsuario: function () {
        let _this = this

        if (_this.usuarioEstaLogado == false) {
          axios
            .get('/api/anunciantes/verificar-sessao')
            .then(function (response) {
              if (response.data.status && response.data.status == 'success') {
                _this.cadastroPorLoginSocial = response.data.data.possui_login_social
                _this.anuncianteLogadoPossuiPlanoAtivo = response.data.data.possui_plano_ativo
                _this.jaPossuiCadastroAnunciante = response.data.data.possui_cadastro_anunciante
                _this.usuarioEstaLogado = response.data.data.possui_cadastro_anunciante || response.data.data.possui_cadastro_usuario

                if (_this.paginaLoginUsuario == false) {
                  if (_this.objFormDadosPagamento.plano != 'gratis') {
                    if (response.data.data.possui_cadastro_anunciante == true) {
                      _this.anuncianteLogado = response.data.data.data.anunciante
                      _this.objFormDadosPagamento.cartao_titular = response.data.data.data.anunciante.nome
                      _this.trocarEtapa('formaPgto')
                    } else if (response.data.data.possui_cadastro_usuario == true) {
                      _this.objForm.nome_completo = response.data.data.data.usuario.nome
                      _this.objForm.email_responsavel = response.data.data.data.usuario.email
                      _this.objForm.telefone = response.data.data.data.usuario.telefone
                      _this.trocarEtapa('cadastro')
                      _this.trocarEtapa('cadastro')
                      _this.trocarEtapa('cadastro')
                    } else if (response.data.data.possui_cadastro_anunciante == false && _this.etapas.cadastro == true) {
                      _this.iniciarlizarEtapaCadastro()
                    } else if (response.data.data.possui_cadastro_usuario == false && _this.etapas.cadastro == true) {
                      _this.iniciarlizarEtapaCadastro()
                    }
                  } else {
                    if (response.data.data.possui_cadastro_anunciante == true && response.data.data.possui_plano_ativo == false) {
                      _this.veioPeloPlanoGratisEPossuiCadastroDeAnuncianteSemPlano = true
                      _this.objForm.nome_completo = response.data.data.data.anunciante.nome
                      _this.iniciarlizarEtapaCadastro()
                    } else if (response.data.data.possui_cadastro_usuario == true && response.data.data.possui_plano_ativo == false) {
                      _this.objForm.nome_completo = response.data.data.data.usuario.nome
                      _this.objForm.email_responsavel = response.data.data.data.usuario.email
                      _this.objForm.telefone_responsavel = response.data.data.data.usuario.telefone
                      _this.iniciarlizarEtapaCadastro()
                    } else if (
                      response.data.data.possui_cadastro_usuario == false &&
                      response.data.data.possui_cadastro_anunciante == false &&
                      response.data.data.possui_plano_ativo == false
                    ) {
                      _this.iniciarlizarEtapaCadastro()
                    }
                  }
                } else {
                  if (_this.usuarioEstaLogado == true) {
                    window.location.href = '/'
                  }
                }
              }
            })
            .catch(function (response) {})
        }
      },
      verificarEmailJaCadastrado: function (email) {
        return axios.get('/api/anunciantes/verifica-novo-cadastro?email=' + email)
      },
      verificarFormularioPgto: function () {
        if (this.enviandoValidacaoFormaPgto == true) {
          return true
        }

        if (this.pagamentoSelecionado == '') {
          return true
        }

        if (this.pagamentoSelecionado == 'boleto') {
          return false
        }

        if (this.pagamentoSelecionado == 'cartao') {
          if (
            this.objFormDadosPagamento.cartao_titular &&
            this.objFormDadosPagamento.cartao_numero &&
            this.objFormDadosPagamento.cartao_validade &&
            this.objFormDadosPagamento.cartao_cvv
          ) {
            return false
          }

          return true
        }

        return true
      },
      pegarInformacoesDoPlano: function () {
        let url = window.location.pathname
        let urlDividida = url.split('/')

        if (urlDividida[3]) {
          urlDividida = urlDividida[3].replace('#', '')

          switch (urlDividida) {
            case '1-imovel':
              return '<p class="anuncio">anúncio de</p><p class="maior">1 imóvel</p>'
              break
            case '20-imoveis':
              return '<p class="anuncio">anúncio de até</p><p class="maior">20 imóveis</p>'
              break
            case '100-imoveis':
              return '<p class="anuncio">anúncio de até</p><p class="maior">100 imóveis</p>'
              break
            case '200-imoveis':
              return '<p class="anuncio">anúncio de até</p><p class="maior">200 imóveis</p>'
              break
            case '400-imoveis':
              return '<p class="anuncio">anúncio de até</p><p class="maior">400 imóveis</p>'
              break
            case 'ilimitado':
              return '<p class="anuncio">anúncio</p><p class="maior">ILIMITADO</p>'
              break
          }
        }
      },
      pegarValorDoPlano: function () {
        let url = window.location.pathname
        let urlDividida = url.split('/')

        if (urlDividida[3]) {
          urlDividida = urlDividida[3].replace('#', '')

          switch (urlDividida) {
            case '1-imovel':
              return '9,90'
              break
            case '20-imoveis':
              return '99'
              break
            case '100-imoveis':
              return '230'
              break
            case '200-imoveis':
              return '345'
              break
            case '400-imoveis':
              return '460'
              break
            case 'ilimitado':
              return '925'
              break
          }
        }
      },
      pegarClasseIconeDoPlano: function () {
        let url = window.location.pathname
        let urlDividida = url.split('/')

        if (urlDividida[3]) {
          urlDividida = urlDividida[3].replace('#', '')

          switch (urlDividida) {
            case '1-imovel':
              return 'plano-1'
              break
            case '20-imoveis':
              return 'plano-20'
              break
            case '100-imoveis':
              return 'plano-100'
              break
            case '200-imoveis':
              return 'plano-200'
              break
            case '400-imoveis':
              return 'plano-400'
              break
            case 'ilimitado':
              return 'plano-ilimitado'
              break
          }
        }
      },
      validarFormaPgto: function () {
        let _this = this
        _this.enviandoValidacaoFormaPgto = true

        let cartaoNumeroIpt = document.getElementById('cartao_numero')
        let cartaoValidadeIpt = document.getElementById('cartao_validade')
        let cartaoCvvIpt = document.getElementById('cartao_cvv')

        cartaoNumeroIpt.classList.remove('error')
        cartaoValidadeIpt.classList.remove('error')
        cartaoCvvIpt.classList.remove('error')

        if (this.pagamentoSelecionado == 'cartao') {
          this.objFormDadosPagamento.pagamento = 'cartao'

          if (!$.payment.validateCardNumber($('input[name=cartao_numero]').val())) {
            swal({
              title: 'Algo deu errado!',
              html: 'O número do cartão de crédito é inválido. <br /> <br /> Verifique os dados preenchidos e tente novamente.',
              type: 'error'
            })

            cartaoNumeroIpt.classList.add('error')
            _this.enviandoValidacaoFormaPgto = false
            return false
          }

          var exp = $('input[name=cartao_validade]').val().split('/')

          if (exp[1].length != 4) {
            swal({
              title: 'Algo deu errado!',
              html:
                'A data de validade deve estar no <br />formato mm/aaaa (ex: 11/2020). <br /> <br /> Verifique os dados preenchidos e tente novamente.',
              type: 'error'
            })

            cartaoValidadeIpt.classList.add('error')
            _this.enviandoValidacaoFormaPgto = false
            return false
          }

          if (!$.payment.validateCardExpiry(exp[0], exp[1])) {
            swal({
              title: 'Algo deu errado!',
              html: 'A data de validade informada é inválida. <br /> <br /> Verifique os dados preenchidos e tente novamente.',
              type: 'error'
            })

            cartaoValidadeIpt.classList.add('error')
            _this.enviandoValidacaoFormaPgto = false
            return false
          }

          if (!$.payment.validateCardCVC($('input[name=cartao_cvv]').val(), $.payment.cardType($('input[name=cartao_numero]').val()))) {
            swal({
              title: 'Algo deu errado!',
              html:
                'O código de segurança do seu cartão de crédito informado é inválido. <br /> <br /> Verifique os dados preenchidos e tente novamente.',
              type: 'error'
            })

            cartaoCvvIpt.classList.add('error')
            _this.enviandoValidacaoFormaPgto = false
            return false
          }

          axios
            .post('/api/anunciantes/validar-cartao-credito', this.objFormDadosPagamento)
            .then(function (response) {
              _this.enviandoValidacaoFormaPgto = false

              if (response.data.status && response.data.status == 'error') {
                swal({
                  title: 'Atenção!',
                  text: response.data.message,
                  type: 'warning'
                })

                if (response.data.message.indexOf('Número') != -1) {
                  cartaoNumeroIpt.classList.add('error')
                }

                if (response.data.message.indexOf('Data') != -1) {
                  cartaoValidadeIpt.classList.add('error')
                }

                if (response.data.message.indexOf('Código') != -1) {
                  cartaoCvvIpt.classList.add('error')
                }
              } else if (response.data.status && response.data.status == 'success') {
                _this.trocarEtapa('confirmacaoDados')
              }
            })
            .catch(function (response) {})
        } else {
          _this.enviandoValidacaoFormaPgto = false
          this.objFormDadosPagamento.pagamento = 'boleto'
          this.trocarEtapa('confirmacaoDados')
        }
      },
      pegarCidade: function () {
        let cidadeInput = document.getElementById('cidade')

        if (cidadeInput.selectedIndex >= 0) {
          this.objForm.cidade_nome = cidadeInput.options[cidadeInput.selectedIndex].text
        }
      },
      enviarCadastroPlano: function () {
        let _this = this
        _this.enviandoConfirmacaoCadastro = true

        this.objFormDadosPagamento.perfil = this.anuncianteLogado.perfil

        var modalTexto =
          '<div class="modal-form-anunciar"><div class="modal-form-anunciar-titulo">Seu cadastro:</div><p class="modal-form-texto-info"></p></div>'
        var execucaoMessage = [
          'Criando sua conta...',
          'Criando seu usuário de acesso...',
          'Adicionando suas permissões...',
          'Finalizando...'
        ]

        var execucao = 0

        $('#modal .modal-data').html(modalTexto)
        $('#modal .modal-data .modal-form-texto-info').html(execucaoMessage[execucao])
        $('#modal').show()
        $('#modal .modal-fechar').hide()

        var atualizaMensagens = setInterval(function () {
          if (execucao >= 0 && execucao <= 3) {
            execucao++
            $('#modal .modal-data .modal-form-texto-info').html(execucaoMessage[execucao])
          }
        }, 800)

        axios
          .post('/api/anunciantes/cadastrar', this.objFormDadosPagamento)
          .then(function (response) {
            clearTimeout(atualizaMensagens)

            if (response.data.status && response.data.status == 'error') {
              swal({
                title: 'Atenção!',
                text: response.data.message,
                type: 'warning'
              })

              _this.enviandoConfirmacaoCadastro = false
            } else if (response.data.status && response.data.status == 'success') {
              // if (ga) ga('send', 'pageview', '/anuncie/novo-cadastro/concluido')

              $('#modal .modal-data .modal-form-texto-info').html(response.data.message)
              $('#modal .modal-data .modal-form-anunciar-titulo').html('Sucesso!')
              $('#modal .modal-data .modal-form-anunciar').append(
                '<br /><p class="more-text center" class="center">Enviamos para seu e-mail os dados de acesso à sua conta. Caso não tenha recebido, você poderá recuperar sua senha acessando a área de <a href="/password/reset"  target="_blank">recuperação de senha</a> no login da área de anunciantes.</p>'
              )
              $('#modal .modal-data .modal-form-anunciar').append(
                '<br /><br /><p class="center"><a class="btn" href="/anunciantes" target="_blank">Área de Anunciantes</a></p>'
              )
              $('#modal .modal-data .modal-form-anunciar').append(
                '<br /><br /><p class="center more-text" style=""><a href="/">Voltar para o site</a></p>'
              )
            }
          })
          .catch(function (response) {})
      },
      inicializarInformacaoDoPlano: function () {
        let url = window.location.pathname
        let urlDividida = url.split('/')

        if (urlDividida[3]) {
          urlDividida = urlDividida[3].replace('#', '')
          this.objFormDadosPagamento.plano = urlDividida
        }
      },
      validarCadastro: function () {
        var hasError = 0

        $('#anuncie-cadastre-form .campo-validacao-obrigatorio').each(function (index, el) {
          if ($(el).val() == '' && !$(el)[0].hasAttribute('disabled') && $(el).css('display') != 'none') {
            el.classList.add('error')
            hasError = 1
          } else {
            el.classList.remove('error')
          }
        })

        if (hasError) {
          swal({
            title: 'Informe todos os campos obrigatórios!',
            text: 'Confira se você digitou corretamente todos os campos obrigatórios e tente novamente.',
            type: 'error'
          })

          return false
        }

        return true
      },
      validarLogin: function () {
        let senhaIpt = document.getElementById('senha')
        let emailIpt = document.getElementById('email')

        senhaIpt.classList.remove('error')
        emailIpt.classList.remove('error')

        var hasError = 0

        $('#anuncie-login-form .campo-validacao-obrigatorio').each(function (index, el) {
          if ($(el).val() == '') {
            el.classList.add('error')
            hasError = 1
          } else {
            el.classList.remove('error')
          }
        })

        if (hasError) {
          swal({
            title: 'Informe todos os campos obrigatórios!',
            text: 'Confira se você digitou corretamente todos os campos obrigatórios e tente novamente.',
            type: 'error'
          })

          return false
        }

        return true
      },
      validarEmail: function (email) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(email)) {
          return true
        }

        return false
      },
      enviarLogin: function () {
        let _this = this
        _this.enviandoLogin = true

        if (!_this.validarLogin()) {
          _this.enviandoLogin = false
          return false
        }

        if (!this.validarEmail(this.objFormLogin.email)) {
          let emailIpt = document.getElementById('email')
          emailIpt.classList.add('error')

          swal({
            title: 'O e-mail informado é inválido!',
            text: 'Confira se você digitou corretamente e tente novamente.',
            type: 'error'
          })
          _this.enviandoLogin = false
          return false
        }

        let token = document.getElementById('token-csrf')
        this.objFormLogin._token = token.value
        this.objFormLogin.pagina_login = this.paginaLogin

        axios
          .post('/api/login', this.objFormLogin)
          .then(function (response) {
            _this.enviandoLogin = false

            if (response.data.status == 'success') {
              let url = window.location.pathname

              if (url.search('/anuncie/login') != -1) {
                window.location.href = '/'
                return false
              } else if (url.search('/login') != -1) {
                window.location.href = '/'
                return false
              }

              _this.verificarSessaoUsuario()
            } else if (response.data.status == 'error') {
              swal({
                title: 'E-mail ou senha inválidos!',
                text: 'Confira se você digitou corretamente todos os campos obrigatórios e tente novamente.',
                type: 'error'
              })
            }
          })
          .catch(function (response) {
            swal({
              title: 'Erro inesperado!',
              text: 'Ocorreu um erro inesperado, por favor tente novamente mais tarde.',
              type: 'error'
            })
          })
      },
      renderGoogleLoginButton: function (buttonContainerId) {
        let _this = this

        setTimeout(function () {
          gapi.load('auth2', function () {
            let auth2 = gapi.auth2.getAuthInstance()

            gapi.signin2.render(buttonContainerId, {
              width: 369,
              height: 40,
              onsuccess: function (user) {
                if (!_this.autenticacaoPorFacebook) {
                  _this.autenticacaoPorGoogle = true
                  let profile = auth2.currentUser.get().getBasicProfile()
                  let idToken = user.getAuthResponse().id_token

                  axios.post('/api/anunciantes/login-social', { token: idToken, type: 'google' }).then(function (response) {
                    _this.possui_plano_ativo = response.data.data.possui_plano_ativo

                    if (response.data.data.possui_cadastro_por_login_social == false && _this.paginaLogin == false) {
                      _this.objForm.nome_completo = profile.getName()

                      if (profile.getEmail()) {
                        _this.objForm.email_responsavel = profile.getEmail()
                        _this.emailVeioAtravesDaAutenticacaoSocial = true
                      }

                      _this.objForm.cadastro_por_login_social = true
                      _this.objForm.google_id = profile.getId()
                      _this.objForm.google_token = idToken

                      _this.cadastroPorLoginSocial = true

                      if (_this.etapas.login == true) {
                        _this.trocarEtapa('cadastro')
                      }
                    } else if (response.data.data.possui_cadastro_por_login_social == true && _this.paginaLogin == false) {
                      if (!_this.veioPeloPlanoGratisEPossuiCadastroDeAnuncianteSemPlano) {
                        _this.verificarSessaoUsuario()
                      }
                    } else if (
                      response.data.data.possui_cadastro_por_login_social == true &&
                      _this.paginaLogin == true &&
                      _this.paginaLoginUsuario == false
                    ) {
                      window.location.href = '/anuncie'
                    } else if (
                      response.data.data.possui_cadastro_por_login_social == false &&
                      _this.paginaLogin == true &&
                      _this.paginaLoginUsuario == false
                    ) {
                      swal({
                        title: 'Cadastro não encontrado',
                        text:
                          "Você não possui cadastro através do Google. Faça seu registro na página de <a href='/anuncie'>anunciantes</a> para acessar a área restrita.",
                        type: 'error'
                      })
                    } else if (response.data.data.possui_cadastro_por_login_social == false && _this.paginaLoginUsuario == true) {
                      let localStorage = window.localStorage
                      localStorage.setItem('login_social_media', true)
                      localStorage.setItem('nome', profile.getName())
                      localStorage.setItem('email', profile.getEmail())
                      localStorage.setItem('google_id', profile.getId())
                      localStorage.setItem('facebook_id', '')
                      window.location.href = '/register'
                    } else if (response.data.data.possui_cadastro_por_login_social == true && _this.paginaLoginUsuario == true) {
                      window.location.href = '/'
                    }
                  })
                }
              },
              onerror: function (error) {}
            })
          })
        }, 1500)
      },
      logoutGoogle: function () {
        let _this = this

        var auth2 = gapi.auth2.getAuthInstance()

        auth2.signOut().then(function () {
          _this.autenticacaoPorGoogle = false
          _this.trocarEtapa('cadastro')
          _this.resetarCadastroPorLoginSocial()
        })
      },
      logoutGoogleSemResetarForm: function () {
        let _this = this

        var auth2 = gapi.auth2.getAuthInstance()
        auth2.signOut().then(function () {
          _this.autenticacaoPorGoogle = false
          _this.objForm.google_id = ''
          _this.objForm.google_token = ''
          _this.anuncianteLogadoPossuiPlanoAtivo = false
        })
      },
      pegarPerfilAnunciante: function () {
        switch (this.anuncianteLogado.perfil) {
          case 'corretor':
            return 'Corretor de imóveis'
            break
          case 'imobiliaria':
            return 'Imobiliária'
            break
          case 'construtora':
            return 'Construtora'
            break
          case 'proprietario':
            return 'Proprietário'
            break
        }
      },
      pegarCidadeEscolhida: function () {
        let uri = window.location.search.substring(1)
        let params = new URLSearchParams(uri)
        this.objForm.cidade = params.get('cidade')
      },
      verificarSeFacebookEstaLogado: function () {
        let _this = this

        if (typeof FB !== 'undefined') {
          FB.getLoginStatus(function (response) {
            if (response.status == 'connected') {
              _this.callBackFacebookLogado(response)
            }
          })
        }
      },
      logoutFacebook: function (response) {
        _this = this

        if (typeof FB !== 'undefined') {
          FB.getLoginStatus(function (response) {
            if (response.status === 'connected') {
              FB.logout(function () {
                _this.autenticacaoPorFacebook = false
                _this.trocarEtapa('cadastro')
                _this.resetarCadastroPorLoginSocial()
              })
            }
          })
        }
      },
      resetarCadastroPorLoginSocial: function () {
        this.cadastroPorLoginSocial = false
        this.objForm.nome_completo = ''
        this.objForm.email_responsavel = ''
        this.objForm.cadastro_por_login_social = false
        this.objForm.facebook_id = ''
        this.objForm.google_id = ''
        this.emailVeioAtravesDaAutenticacaoSocial = false
        this.veioPeloPlanoGratisEPossuiCadastroDeAnuncianteSemPlano = false
        this.anuncianteLogadoPossuiPlanoAtivo = false
        this.usuarioEstaLogado = false
      },
      logarComFacebook: function () {
        _this = this
        if (typeof FB !== 'undefined') {
          FB.login(
            function (response) {
              if (response.authResponse) {
                _this.callBackFacebookLogado(response)
              }
            },
            { scope: 'public_profile, email' }
          )
        }
      },
      callBackFacebookLogado: function (responseCallback) {
        _this = this

        axios
          .post('/api/anunciantes/login-social', { token: responseCallback.authResponse.accessToken, type: 'facebook' })
          .then(function (response) {
            if (response.data.data.possui_cadastro_por_login_social == false && _this.paginaLogin == false) {
              if (typeof FB !== 'undefined') {
                FB.api('/me?fields=id,name,email', function (facebookRes) {
                  _this.cadastroPorLoginSocial = true
                  _this.autenticacaoPorFacebook = true
                  _this.objForm.nome_completo = facebookRes.name
                  _this.objForm.cadastro_por_login_social = true
                  _this.objForm.facebook_id = facebookRes.id

                  if (facebookRes.email != undefined) {
                    _this.objForm.email_responsavel = facebookRes.email
                    _this.emailVeioAtravesDaAutenticacaoSocial = true
                  }

                  if (_this.etapas.login == true) {
                    _this.trocarEtapa('cadastro')
                  }
                })
              }
            } else if (response.data.data.possui_cadastro_por_login_social == true && _this.paginaLogin == false) {
              _this.verificarSessaoUsuario()
            } else if (
              response.data.data.possui_cadastro_por_login_social == true &&
              _this.paginaLogin == true &&
              _this.paginaLoginUsuario == false
            ) {
              window.location.href = '/anuncie'
            } else if (
              response.data.data.possui_cadastro_por_login_social == false &&
              _this.paginaLogin == true &&
              _this.paginaLoginUsuario == false
            ) {
              swal({
                title: 'Cadastro não encontrado',
                text:
                  "Você não possui cadastro através do Facebook. Faça seu registro na página de <a href='/anuncie'>anunciantes</a> para acessar a área restrita.",
                type: 'error'
              })
            } else if (response.data.data.possui_cadastro_por_login_social == false && _this.paginaLoginUsuario == true) {
              if (typeof FB !== 'undefined') {
                FB.api('/me?fields=id,name,email', function (facebookRes) {
                  let localStorage = window.localStorage
                  localStorage.setItem('login_social_media', true)
                  localStorage.setItem('nome', facebookRes.name)
                  localStorage.setItem('email', facebookRes.email)
                  localStorage.setItem('facebook_id', facebookRes.id)
                  localStorage.setItem('google_id', '')
                  window.location.href = '/register'
                })
              }
            } else if (response.data.data.possui_cadastro_por_login_social == true && _this.paginaLoginUsuario == true) {
              window.location.href = '/'
            }
          })
      },
      verificarRedundanciaAutenticacaoSocial: function () {
        _this = this

        setInterval(function () {
          if (_this.autenticacaoPorFacebook == true && _this.autenticacaoPorGoogle == true) {
            _this.logoutGoogleSemResetarForm()
          }
        }, 700)
      }
    },
    mounted() {
      this.verificarRedundanciaAutenticacaoSocial()
      this.verificarSeFacebookEstaLogado()
      this.pegarCidadeEscolhida()
      this.inicializarInformacaoDoPlano()
      this.carregarCidades()
      this.verificarSessaoUsuario()
      $('#container-etapas').css('display', 'block')
      $('#container-etapas').css('height', 'auto')

      let url = window.location.pathname

      if (url.search('/anuncie/login') != -1) {
        this.etapas.cadastro = false
        this.etapas.login = true
        this.inicializarEtapaLogin()
        this.paginaLogin = true
      } else if (url.search('/login') != -1) {
        this.etapas.cadastro = false
        this.etapas.login = true
        this.inicializarEtapaLogin()
        this.paginaLogin = true
        this.paginaLoginUsuario = true
      } else {
        this.paginaLogin = false
      }
    }
  })
}
